import React, { useState, useEffect } from "react";
import axios from "axios";
import { message } from "antd";
import { InputItem, InputNumberItem, ModalItem } from "../../../../../Components/Items";

const valoresIniciales = { nombre: "", ancho: 1000, alto: 700, pixelesPorMetro: 10 };

const ModalCrearMapa = ({ visible, onClose, empresaId, proyectoId, headersToken, onCreado }) => {
  const [valores, setValores] = useState(valoresIniciales);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    if (visible) setValores(valoresIniciales);
  }, [visible]);

  const actualizar = (cambios) => setValores((prev) => ({ ...prev, ...cambios }));

  const crear = async () => {
    //El modelo del backend exige nombre, ancho y alto: sin esto el guardado truena y el usuario
    //solo ve "Error al crear el mapa del almacén" sin saber qué le faltó.
    const nombre = (valores.nombre || "").trim();
    if (!nombre) {
      message.error("Escribe el nombre del mapa");
      return;
    }
    if (!(valores.ancho > 0) || !(valores.alto > 0)) {
      message.error("El ancho y el alto deben ser mayores a cero");
      return;
    }

    setGuardando(true);
    try {
      const res = await axios.post(
        "mapaAlmacen/agregarMapaAlmacen",
        {
          empresaId,
          proyectoId,
          nombre,
          ancho: valores.ancho,
          alto: valores.alto,
          unidadCoordenadas: "pixeles",
          pixelesPorMetro: valores.pixelesPorMetro || 10,
        },
        { headers: headersToken }
      );
      if (res.data.success === 2) {
        message.success("Mapa creado correctamente");
        onClose();
        onCreado();
      } else {
        message.error(res.data.error || "No se pudo crear el mapa");
      }
    } catch (error) {
      console.error("Error al crear el mapa:", error);
      message.error("No se pudo crear el mapa");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <ModalItem
      title="Crear mapa del almacén"
      visible={visible}
      onCancel={onClose}
      onOk={crear}
      width={520}
      footer
      spinning={guardando}
      confirmLoading={guardando}
    >
      <div style={{ marginBottom: 12 }}>
        <div style={{ marginBottom: 4, color: "#6b7280" }}>Nombre</div>
        <InputItem value={valores.nombre} onChange={(e) => actualizar({ nombre: e.target.value })} />
      </div>
      <div style={{ display: "flex", gap: 12 }}>
        <div style={{ flex: 1 }}>
          <div style={{ marginBottom: 4, color: "#6b7280" }}>Ancho (px)</div>
          <InputNumberItem style={{ width: "100%" }} value={valores.ancho} onChange={(v) => actualizar({ ancho: v })} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ marginBottom: 4, color: "#6b7280" }}>Alto (px)</div>
          <InputNumberItem style={{ width: "100%" }} value={valores.alto} onChange={(v) => actualizar({ alto: v })} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ marginBottom: 4, color: "#6b7280" }}>Píxeles por metro</div>
          <InputNumberItem style={{ width: "100%" }} value={valores.pixelesPorMetro} onChange={(v) => actualizar({ pixelesPorMetro: v })} />
        </div>
      </div>
    </ModalItem>
  );
};

export default ModalCrearMapa;
